export async function apiCall(endpoint, method = 'POST', body = null) {
    try {
        const BASE_URL=process.env.REACT_APP_API_BASE_URL
        console.log("BASE URL",BASE_URL)
        const url = `${BASE_URL}/${endpoint}`;
        
        const options = {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('adminToken'), 
            },
            body: body ? JSON.stringify(body) : null,
        };
        
        const response = await fetch(url, options);
        const data = await response.json(); 

        if (!response.ok) {
            return { success: false, message: data.message || 'Failed to fetch data' };
        }

        return { success: true, data }; 
    } catch (error) {
        console.error('API Error:', error);
        return { success: false, message: 'API Error occurred' }; 
    }
}
